var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"start-border",style:({ display: 'none' })}),_vm._v(" "),_c('div',{staticClass:"end-border",style:({ display: 'none' }),attrs:{"id":"endBorder"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }